module.exports = __webpack_public_path__ + "static/img/third3_1_active.4d9565d2.png";